import { usePermissionStore } from '../stores/permissionStore';

export const usePermission = (permission: string) => {
  const { hasPermission } = usePermissionStore();
  return hasPermission(permission);
};

export const usePermissions = (permissions: string[], mode: 'all' | 'any' = 'any') => {
  const { hasAnyPermission, hasAllPermissions } = usePermissionStore();
  return mode === 'all' ? hasAllPermissions(permissions) : hasAnyPermission(permissions);
};

export const useMenuPermissions = () => {
  const { menuPermissions } = usePermissionStore();
  return menuPermissions;
};